module.exports = __webpack_public_path__ + "img/get-cafe-bazzar.e96f1bb7.png";